enum UserType {
    Agent = 'Agent',
    TeamLeader = 'Team Leader',
    QA = 'QA'
}

export default UserType